import { store } from '../store'
import {firestore} from '@/plugins/firebase'

const acceptedLanguages = ['en', 'es']

function updateLanguageInDoc (userDoc, language) {
  firestore.then(db => {
    db.collection('app/v1/users').doc(userDoc.id).get()
    .then(doc => {
      const userSettings = doc.data().settings ? doc.data().settings : {}
      userSettings.preferredLanguage = language
      db.collection('app/v1/users').doc(userDoc.id).update({settings: userSettings})
    })
    .catch(error => {
      console.log(error)
    })
  })
}

function getLanguage (doc) {
  let docData
  if (doc) {
    docData = doc.data()
  }
  if (docData && docData.settings && docData.settings.preferredLanguage && acceptedLanguages.includes(docData.settings.preferredLanguage)) {
    store.commit('setLanguage', docData.settings.preferredLanguage)
    return docData.settings.preferredLanguage
  } else {
    let language = ''
    const storedLanguage = store.getters.language
    if (storedLanguage) {
      language = storedLanguage
    } else {
      const browserLanguage = navigator.language ? navigator.language.split('-')[0] : null
      if (browserLanguage && acceptedLanguages.includes(browserLanguage)) {
        store.commit('setLanguage', browserLanguage)
        language = browserLanguage
      } else {
        store.commit('setLanguage', 'en')
        language = 'en'
      }
    }
    if (docData) {
      updateLanguageInDoc(doc, language)
    }
    return language
  }
}

export default getLanguage



// WEBPACK FOOTER //
// ./src/lib/get-language.js